<template>
  <div id="home">
    <div class="nav-container">
      <div v-for="item in 2" :key="item + 'cont'">
        <div
          v-for="(itemC, indexC) in getNavList(item)"
          :key="indexC"
          :class="`height-${itemC.level}`"
          @click="goPath(itemC)"
        >
          <img :src="require(`../assets/images/${itemC.pic}`)" />
          <span>{{ itemC.title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import storageHelper from "../utils/storage";
export default {
  name: "home",
  data() {
    return {
      navList: [
        {
          title: "高效巡店",
          pic: "nav_1.png",
          level: 2,
          icon: "patrolShop",
        },
        {
          title: "小鸟探店",
          pic: "nav_2.png",
          level: 3,
          icon: "storeVisit",
        },
        {
          title: "智能信发",
          pic: "nav_4.png",
          level: 3,
          icon: "smartAds",
        },
        {
          title: "开店筹建",
          pic: "nav_11.png",
          level: 3,
          icon: "establishment",
        },
        {
          title: "招商管理",
          pic: "nav_12.png",
          level: 3,
          icon: "investment",
        },

        {
          title: "视频追溯",
          pic: "nav_6.png",
          level: 3,
          icon: "videoTracing",
        },
        {
          title: "客流动线分析",
          pic: "nav_7.png",
          level: 3,
          icon: "peopleCount",
        },
        {
          title: "AI识别",
          pic: "nav_3.png",
          level: 2,
          icon: "aiDetection",
        },
        {
          title: "员工激励与成长",
          pic: "nav_10.png",
          level: 3,
          icon: "motivateGrowth",
        },

        {
          title: "数据中心",
          pic: "nav_8.png",
          level: 2,
          icon: "dataCenter",
        },
        // {
        //   title: "线上引流",
        //   pic: "nav_9.png",
        //   level: 3,
        //   icon: "onlineDrainage",
        // },
        // {
        //   title: "远程协同",
        //   pic: "nav_5.png",
        //   level: 3,
        //   icon: "smartOA",
        // },
      ],
    };
  },

  created() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color: #f0f0f0");
    storageHelper.removeTempData("AIType");
  },

  methods: {
    /**
     * 跳转至详情页面
     */
    goPath({ icon }) {
      this.$router.push({
        path: "/commonPage",
        query: {
          key: icon,
        },
      });
    },

    /**
     * 菜单列表展示
     */
    getNavList(index) {
      let half = Math.ceil(this.navList.length / 2);
      if (index == 1) {
        return this.navList.slice(0, half);
      }
      return this.navList.slice(half);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";
#home {
  padding: 16px;
  // background-color: #f0f0f0;
  .nav-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      width: calc(50% - 5.5px);
      > div {
        border-radius: 12px;
        background-color: white;
        box-shadow: 0 4px 11px 0 #0000000f;
        margin-bottom: 11px;
        padding: 12px;
        text-align: left;
        background-size: contain;
        background-position: bottom;
        background-repeat: no-repeat;
        position: relative;
        overflow: hidden;
        span {
          font-size: 18px;
          font-weight: 600;
          line-height: 18px;
        }
        img {
          position: absolute;
          right: 0;
          bottom: 0;
          max-width: 100%;
        }
        &.height-1 {
          height: 200px;
        }
        &.height-2 {
          height: 130px;
        }
        &.height-3 {
          height: 106px;
        }
      }
    }
  }
}
@media screen and (min-width: $maxWidth) {
  #home {
    padding: 16px 0px;
    margin: 0 auto;
    .nav-container {
      > div {
        width: calc(50% - 5.5px);
        > div {
          border-radius: 12px;
          box-shadow: 0 4px 11px 0 #0000000f;
          margin-bottom: 11px;
          padding: 12px;
          span {
            font-size: 22px;
            line-height: 18px;
          }
          img {
            max-height: 100%;
          }
          &.height-1 {
            height: 200px;
          }
          &.height-2 {
            height: 130px;
          }
          &.height-3 {
            height: 106px;
          }
        }
      }
    }
  }
}
</style>
